/**
 * Computes shared bar segment ratios for container occupancy charts.
 *
 * @param {Object} params
 * @param {number|null} params.capacity
 * @param {number} params.available
 * @param {number} params.occupied
 * @param {number} [params.maintenance=0]
 * @returns {{
 *   capacity: number|null,
 *   available: number,
 *   occupied: number,
 *   maintenance: number,
 *   usedCapacity: number,
 *   remainingCapacity: number,
 *   occupiedRatio: number,
 *   availableRatio: number,
 *   maintenanceRatio: number,
 *   capacityRatio: number,
 *   isNotSold: boolean
 * }}
 */
export function getContainerBarSegments({
  capacity,
  available,
  occupied,
  maintenance = 0,
}) {
  const total = capacity !== null ? capacity : 1;
  const usedCapacity = occupied + available + maintenance;
  const remainingCapacity =
    capacity !== null ? Math.max(0, capacity - usedCapacity) : 0;
  const toRatio = (value) => (value > 0 ? value / total : 0);

  return {
    capacity,
    available,
    occupied,
    maintenance,
    usedCapacity,
    remainingCapacity,
    occupiedRatio: toRatio(occupied),
    availableRatio: toRatio(available),
    maintenanceRatio: toRatio(maintenance),
    capacityRatio: capacity !== null ? toRatio(remainingCapacity) : 0,
    isNotSold: capacity === null,
  };
}
